module.exports = __webpack_public_path__ + "static/media/28DGC2.ce21cb1d.jpg";